import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [phone, setPhone] = useState(null);

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    const savedPhone = localStorage.getItem("user_phone");
    if (savedUser) setUser(JSON.parse(savedUser));
    if (savedPhone) setPhone(savedPhone);
  }, []);

  const login = (userData) => {
    setUser(userData);
    if (userData.phone) {
      localStorage.setItem("user_phone", userData.phone);
      setPhone(userData.phone);
    }
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setPhone(null);
    localStorage.removeItem("user");
    localStorage.removeItem("user_phone");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  };

  const isAuthenticated = !!localStorage.getItem("access_token");

  return (
    <AuthContext.Provider
      value={{ user, phone, login, logout, isAuthenticated }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
